var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BuildStatus } from '../../../../enums/build-status';
import { WlmUrls } from '../../../../enums/workload/wlm-urls';
import { SlaBoundaries } from '../../../../enums/workload/sla-boundaries';
import { StaffService } from '../../../../services/workload/staff.service';
import { TicketInformationService } from '../../../../services/workload/ticket-information.service';
var RequestTableComponent = /** @class */ (function () {
    function RequestTableComponent(staffService, ticketService) {
        this.staffService = staffService;
        this.ticketService = ticketService;
        this.pinned = of([]);
        this.requests = of([]);
        this.status = BuildStatus.ReadyToBuild;
        this.totalCount = 0;
        this.pageSize = 20;
        this.isReadonly = false;
        this.pageChanged = new EventEmitter();
        this.page = 0;
        this.sub = [];
        this.viewModel = {
            headers: {
                basketId: 'Basket Id',
                requestId: 'Request Id',
                customer: 'Customer',
                customerEmail: 'Email',
                centreName: 'Centre',
                requestDate: 'Request Date',
                action: 'Action',
                awardingBody: 'Awarding Body',
                qualTitle: 'Qual Title',
                slaNew: 'SLA (New)',
                qualSizeUnitComplexity: 'Estimated Size',
                estimatedStartDate: 'Estimated Start Date',
                status: 'Status',
                assigned: 'Assigned',
                ticketId: 'Ticket Id',
                dueDate: 'Due Date',
                dateAmended: 'Amended request Date',
                dateAssigned: 'Date Assigned',
                approvalDate: 'Date Customer Approved',
                assignedToPracticeDate: 'Date Assigned to Practice',
                customerApprovedDate: 'Customer Approved Date',
                liveDate: 'Live Assigned Date',
                numberOfErrorsFound: 'Number of Errors',
                standardId: 'Standard Id',
                assignedToPrimary: 'Assigned to Primary',
                secondaryStaffMember: 'Assigned to Secondary'
            },
            headersValues: {
                id: 0,
                status: BuildStatus.ReadyToBuild,
                createdOn: null,
                staffId: 0,
                customer: '',
                qualTitle: '',
                centreName: '',
                customerEmail: '',
                slaNew: SlaBoundaries.NotSet,
                acceptedDate: null,
                dateCompleted: null,
                dueDate: null,
                standardId: 0,
                action: 0,
                size: 0,
                requestedStandardId: 0,
                requestedBasketId: 0,
                estimatedStartDate: null,
                secondaryStaffId: 0,
                secondaryStaffMember: null,
                numberOfErrorsFound: null,
                dateAssigned: null,
                amendRequestDate: null,
                assignedToPracticeDate: null,
                liveDate: null,
                weblinkArray: ''
            }
        };
    }
    RequestTableComponent.prototype.getPage = function (page) {
        page--; // API paging is 0 based so page number needs -- before calling and ++ after
        var command = {
            status: this.status,
            page: page
        };
        page++;
        this.page = page;
        this.pageChanged.emit(command);
    };
    RequestTableComponent.prototype.buildRequestUrl = function (requestId) {
        return "" + WlmUrls.Workflow + requestId;
    };
    __decorate([
        Input(),
        __metadata("design:type", Observable)
    ], RequestTableComponent.prototype, "pinned", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Observable)
    ], RequestTableComponent.prototype, "requests", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], RequestTableComponent.prototype, "status", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], RequestTableComponent.prototype, "totalCount", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], RequestTableComponent.prototype, "pageSize", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], RequestTableComponent.prototype, "isReadonly", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], RequestTableComponent.prototype, "pageChanged", void 0);
    RequestTableComponent = __decorate([
        Component({
            selector: 'request-table',
            template: require('./request-table.component.html'),
            styles: [require('./request-table.component.scss')]
        }),
        __metadata("design:paramtypes", [StaffService,
            TicketInformationService])
    ], RequestTableComponent);
    return RequestTableComponent;
}());
export { RequestTableComponent };
//# sourceMappingURL=data:application/json;base64,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